@for (optionPair of this.activeMarket.options | msOptionGroupPair; let i = $index; track optionPair) {
    <div class="market-options" [style.display]="i > 2 && !expanded ? 'none' : 'table'">
        @for (option of optionPair; track option) {
            @if (option) {
                <ms-event-pick
                    class="result"
                    [option]="option"
                    [event]="event"
                    [optionGroup]="this.activeMarket"
                    [trackingSource]="tracking?.source"
                    [trackingGameDetails]="tracking?.gameDetails"
                    [enableOptionIndicator]="false">
                    <ms-tree-option class="card-option" [option]="option" [twoThreeWay]="false" />
                </ms-event-pick>
            } @else {
                <div class="result"></div>
            }
        }
    </div>
}
@if (this.activeMarket.options.length > 6) {
    <div class="show-more" (click)="expanded = !expanded">
        <span>
            {{ expanded ? sitecoreEventDetails.eventDetails.LeftNavShowLess : sitecoreEventDetails.eventDetails.LeftNavShowMore }}
            @if (expanded) {
                <vn-icon name="theme-right" class="expanded" size="12" />
            } @else {
                <vn-icon name="theme-right" class="collapsed" size="12" />
            }
        </span>
    </div>
}
